var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * tab入口
 */
import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { Divider, Popover, Select, Tabs } from 'antd';
import IconFont from '../../IconFont';
import UserSelectionContext from '../context';
import { OrgType, UserSelTab, } from '../types';
import OrgList from './OrgList';
import GroupList from './GroupList';
import TagList from './TagList';
import GroupAndMembers from './groupAndMembers';
import TabPaneList from './TabPaneList';
import classNames from 'classnames';
import { CaretDownOutlined } from '@ant-design/icons';
import BusinessTabPaneList from './BusinessTabPaneList';
import RecommendPaneList from './RecommendPaneList';
import ContactsList from './ContactsList';
import { contactAndGroupListItem, mapCustomTabListInfo } from '../common';
import WorkLine from './WorkLine';
var Option = Select.Option, OptGroup = Select.OptGroup;
export default function SelectionTabs(props) {
    var _this = this;
    var _a = React.useContext(UserSelectionContext), tabs = _a.tabs, 
    //  customTab,
    //  customTab2,
    contactShowType = _a.contactShowType, frozenIds = _a.frozenIds, selectGroupType = _a.selectGroupType, currentUser = _a.currentUser, customTabs = _a.customTabs, t = _a.t, simpleDeptInfoList = _a.simpleDeptInfoList, virtualDeptInfoList = _a.virtualDeptInfoList, businessTab = _a.businessTab;
    var result = props.result, onItemCheck = props.onItemCheck, onGetEBookDeptInfo = props.onGetEBookDeptInfo, onGetEBookWorkLineInfo = props.onGetEBookWorkLineInfo, onGetEBookOrgInfo = props.onGetEBookOrgInfo, onGetRecentData = props.onGetRecentData, onGetRecentIncludeGroup = props.onGetRecentIncludeGroup, onGetAgentForData = props.onGetAgentForData, onGetTopData = props.onGetTopData, onGetExternalContacts = props.onGetExternalContacts, onGetGroupData = props.onGetGroupData, onGetGroupMembersData = props.onGetGroupMembersData, onGetTagData = props.onGetTagData, onGetTagMembersData = props.onGetTagMembersData, onGetBusinessData = props.onGetBusinessData, onGetRecommendInfo = props.onGetRecommendInfo, onSearchGlobal = props.onSearchGlobal, onAnalysisLog = props.onAnalysisLog, defaultTabActiveKey = props.defaultTabActiveKey, jumpCurrentGroupItem = props.jumpCurrentGroupItem, jumpCurrentOrgItem = props.jumpCurrentOrgItem, clearJumpCurrentGroup = props.clearJumpCurrentGroup, clearJumpCurrentOrg = props.clearJumpCurrentOrg;
    // const firstTab:string = defaultTabActiveKey ? defaultTabActiveKey : tabs[0]; // === UserSelTab.custom && !customTab ? tabs[1] : tabs[0];
    var _b = useState(tabs[0] === UserSelTab.custom ? customTabs[0].tabName : tabs[0]), tabActiveKey = _b[0], setTabActiveKey = _b[1];
    // const [network, setNetwork] = useState(navigator.onLine);
    useEffect(function () {
        if (defaultTabActiveKey) {
            setTabActiveKey(defaultTabActiveKey);
        }
    }, [defaultTabActiveKey]);
    var defaultOrgActiveKey = (simpleDeptInfoList || []).length > 0
        ? simpleDeptInfoList[simpleDeptInfoList.length - 1].deptId
        : '';
    var _c = useState(defaultOrgActiveKey), orgActiveKey = _c[0], setOrgActiveKey = _c[1];
    var _d = useState(OrgType.substantive), orgType = _d[0], setOrgType = _d[1];
    var _e = useState(false), popoverVisible = _e[0], setPopoverVisible = _e[1];
    // tab key 和对应获取数据方法的映射关系
    var getDataFnMap = {
        recommend: onGetRecommendInfo,
        business: onGetBusinessData,
        recent: onGetRecentData,
        agentFor: onGetAgentForData,
        org: onGetEBookDeptInfo,
        workLine: onGetEBookWorkLineInfo,
        top: onGetTopData,
        externalContacts: onGetExternalContacts,
        group: onGetGroupData,
        groupCanBeSel: onGetGroupData,
        groupAndMembers: onGetGroupData,
        recentIncludeGroup: onGetRecentIncludeGroup,
    };
    //  // 是否自定义列表
    //  const isCustomTab = useCallback(
    //      (key: UserSelTab) => {
    //          return key === UserSelTab.custom && customTab && customTab.tabName;
    //      },
    //      [customTab]
    //  );
    //  const isCustomTab2 = useCallback(
    //      (key: UserSelTab) => {
    //          return key === UserSelTab.custom2 && customTab2 && customTab2.tabName;
    //      },
    //      [customTab2]
    //  );
    // 是否业务列表
    var isBusinessTab = useCallback(function (key) {
        return key === UserSelTab.business && businessTab && businessTab.tabName;
    }, [businessTab]);
    var showSelectBox = function () {
        setPopoverVisible(!popoverVisible);
    };
    var handleVisibleChange = function (visible) {
        setPopoverVisible(visible);
    };
    // 实体组织，虚拟组织 每项点击功能
    var orgItemClick = useCallback(function (type, id) {
        if (id === orgActiveKey) {
            return;
        }
        setOrgType(type);
        setOrgActiveKey(id);
        // 拉取数据
        setTabActiveKey(UserSelTab.org);
        setPopoverVisible(false);
    }, [orgActiveKey]);
    // 实体组织
    var substantiveOrganization = useMemo(function () {
        if (!simpleDeptInfoList) {
            return null;
        }
        var _a = simpleDeptInfoList[simpleDeptInfoList.length - 1], deptId = _a.deptId, deptName = _a.deptName;
        var isActive = deptId === orgActiveKey;
        var clsNames = classNames({
            'org-list-item': true,
            active: isActive,
        });
        return (React.createElement("div", null,
            React.createElement("div", { className: "org-title" }, t('userSelection.substantive_organization')),
            React.createElement("div", { className: "org-list" },
                React.createElement("div", { className: clsNames, onClick: orgItemClick.bind(null, OrgType.substantive, deptId) },
                    React.createElement("span", { className: "item-name" }, deptName),
                    isActive && (React.createElement("span", { className: "item-icon" },
                        React.createElement(IconFont, { type: "iconlog_choice" })))))));
    }, [simpleDeptInfoList, orgActiveKey, t, orgItemClick]);
    // 虚拟组织
    var virtualOrganization = useMemo(function () {
        if (!virtualDeptInfoList) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement(Divider, { className: "content-divider" }),
            React.createElement("div", { className: "org-title" }, t('userSelection.virtual_organization')),
            React.createElement("div", { className: "org-list" }, virtualDeptInfoList.map(function (item) {
                return (React.createElement("div", { key: item.topOrgId, className: classNames({
                        'org-list-item': true,
                        active: item.topOrgId === orgActiveKey,
                    }), onClick: orgItemClick.bind(null, OrgType.virtual, item.topOrgId) },
                    React.createElement("span", { className: "item-name" }, item.topOrgName),
                    item.topOrgId === orgActiveKey && (React.createElement("span", { className: "item-icon" },
                        React.createElement(IconFont, { type: "iconlog_choice" })))));
            }))));
    }, [virtualDeptInfoList, t, orgActiveKey, orgItemClick]);
    // 组织架构 选择器， 实体组织，虚拟组织
    var content = useMemo(function () {
        if (!simpleDeptInfoList) {
            return null;
        }
        return (React.createElement("div", { className: "user-selection-tab-popover-content" },
            substantiveOrganization,
            virtualOrganization));
    }, [simpleDeptInfoList, substantiveOrganization, virtualOrganization]);
    var orgTabName = useMemo(function () {
        if (orgType === OrgType.substantive &&
            simpleDeptInfoList &&
            simpleDeptInfoList.length > 0) {
            return simpleDeptInfoList[simpleDeptInfoList.length - 1].deptName;
        }
        if (virtualDeptInfoList && virtualDeptInfoList.length > 0) {
            var data = virtualDeptInfoList.find(function (item) { return item.topOrgId === orgActiveKey; });
            return data.topOrgName || '';
        }
        return '';
    }, [orgActiveKey, orgType, simpleDeptInfoList, virtualDeptInfoList]);
    // 组织架构 tab 节点
    var orgTabNameNode = useMemo(function () {
        if (!tabs.includes(UserSelTab.org)) {
            return null;
        }
        // 显示用户所在最近一级的组织架构 可以下拉选择虚拟组织
        if ((simpleDeptInfoList || []).length > 0) {
            return (React.createElement("span", { className: "tab-name-icon" },
                React.createElement("span", { className: "name" }, orgTabName),
                React.createElement(Popover, { className: "user-selection-tab-popover", content: content, placement: "bottom", trigger: "click", visible: popoverVisible, onVisibleChange: handleVisibleChange },
                    React.createElement(CaretDownOutlined, { onClick: showSelectBox }))));
        }
        else {
            return React.createElement("span", { className: "tan-name" }, "\u7EC4\u7EC7\u901A\u8BAF\u5F55");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [content, orgTabName, showSelectBox, simpleDeptInfoList, t, tabs]);
    var getTabPaneNameNode = useCallback(function (key) {
        // 自定议组织架构tab项
        if (key === UserSelTab.org) {
            return [{ key: key, tabName: orgTabNameNode }];
        }
        else if (isBusinessTab(key)) {
            return [{ key: key, tabName: businessTab.tabName }];
        }
        else if (key === UserSelTab.custom && customTabs.length > 0) {
            return customTabs.map(function (item) {
                return { key: item.tabName, tabName: item.tabName };
            });
        }
        else if (key === UserSelTab.externalContacts) {
            return [{ key: key, tabName: '我的联系人' }];
        }
        else if (key === UserSelTab.tag) {
            return [{ key: key, tabName: '分组' }];
        }
        else if (key === UserSelTab.recent) {
            return [{ key: key, tabName: '常用联系人' }];
        }
        else if (key === UserSelTab.group || key === UserSelTab.groupCanBeSel) {
            return [{ key: key, tabName: '我的群' }];
        }
        else if (key === UserSelTab.workLine) {
            return [{ key: key, tabName: '虚拟通讯录' }];
        }
        else {
            return [{ key: key, tabName: t("userSelection." + key) }];
        }
    }, [isBusinessTab, customTabs, orgTabNameNode, businessTab, t]);
    var onTabClick = function (key, event) {
        if (tabActiveKey !== key) {
            setTabActiveKey(key);
            if (key === UserSelTab.workLine) {
                onAnalysisLog === null || onAnalysisLog === void 0 ? void 0 : onAnalysisLog('xtbg_add_home_1637657110163', '95');
            }
            if (tabs.includes(UserSelTab.group))
                clearJumpCurrentGroup();
            if (tabs.includes(UserSelTab.org))
                clearJumpCurrentOrg();
        }
        event.preventDefault();
        event.stopPropagation();
    };
    var getOrgListNode = useCallback(function () {
        return (React.createElement(OrgList, { result: result, onItemCheck: onItemCheck, onGetEBookDeptInfo: onGetEBookDeptInfo, onGetEBookOrgInfo: onGetEBookOrgInfo, orgId: orgActiveKey, orgType: orgType, jumpCurrentOrgItem: jumpCurrentOrgItem }));
    }, [
        jumpCurrentOrgItem,
        onGetEBookDeptInfo,
        onGetEBookOrgInfo,
        onItemCheck,
        orgActiveKey,
        orgType,
        result,
    ]);
    var getWorkLineListNode = useCallback(function () {
        return (React.createElement(WorkLine, { onAnalysisLog: onAnalysisLog, result: result, jumpCurrentOrgItem: jumpCurrentOrgItem, onItemCheck: onItemCheck, onGetEBookWorkLineInfo: onGetEBookWorkLineInfo }));
    }, [jumpCurrentOrgItem, onAnalysisLog, onGetEBookWorkLineInfo, onItemCheck, result]);
    var getTagListNode = useCallback(function (key) {
        if (tabActiveKey !== key) {
            return;
        }
        return (React.createElement(TagList, { result: result, onItemCheck: onItemCheck, onGetTagData: onGetTagData, onGetTagMembersData: onGetTagMembersData, tabKey: key }));
    }, [onGetTagData, onGetTagMembersData, onItemCheck, result, tabActiveKey]);
    var getGroupListNode = useCallback(function (key) {
        if (tabActiveKey !== key) {
            return;
        }
        return (React.createElement(GroupList, { result: result, onItemCheck: onItemCheck, onGetGroupData: onGetGroupData, onGetGroupMembersData: onGetGroupMembersData, jumpCurrentGroupItem: jumpCurrentGroupItem, tabKey: key }));
    }, [
        jumpCurrentGroupItem,
        onGetGroupData,
        onGetGroupMembersData,
        onItemCheck,
        result,
        tabActiveKey,
    ]);
    var getContactsListNode = useCallback(function (key) {
        return (React.createElement(ContactsList, { result: result, onItemCheck: onItemCheck, tabKey: key, onGetExternalContacts: getDataFnMap[key] }));
    }, [getDataFnMap, onItemCheck, result]);
    var getCustomListNode = useCallback(function (key, tab) {
        return (React.createElement(TabPaneList, { result: result, onItemCheck: onItemCheck, tabKey: key, onGetData: function () { return __awaiter(_this, void 0, void 0, function () {
                var list;
                return __generator(this, function (_a) {
                    if (tab.renderer) {
                        return [2 /*return*/, []];
                    }
                    list = mapCustomTabListInfo(tab.dataList || [], result, frozenIds);
                    if (selectGroupType || contactShowType) {
                        list = contactAndGroupListItem(contactShowType, selectGroupType, list, currentUser);
                    }
                    return [2 /*return*/, list || []];
                });
            }); } }));
    }, [contactShowType, currentUser, frozenIds, onItemCheck, result, selectGroupType]);
    var groupAndMembersNode = useCallback(function () {
        return (React.createElement(GroupAndMembers, { result: result, onItemCheck: onItemCheck, onGetGroupData: onGetGroupData, onGetGroupMembersData: onGetGroupMembersData }));
    }, [result, onItemCheck, onGetGroupData, onGetGroupMembersData]);
    var getBusinessListNode = useCallback(function (key) {
        return (React.createElement(BusinessTabPaneList, { result: result, onItemCheck: onItemCheck, tabKey: key, onGetData: getDataFnMap[key] }));
    }, [getDataFnMap, onItemCheck, result]);
    var getRecommendListNode = useCallback(function (key) {
        return (React.createElement(RecommendPaneList, { result: result, onItemCheck: onItemCheck, tabKey: key, onGetData: getDataFnMap[key] }));
    }, [getDataFnMap, onItemCheck, result]);
    var getCommonListNode = useCallback(function (key) {
        return (React.createElement(TabPaneList, { result: result, onItemCheck: onItemCheck, tabKey: key, onGetData: getDataFnMap[key] }));
    }, [getDataFnMap, onItemCheck, result]);
    var getTabPaneListNode = function (key) {
        if (key !== tabActiveKey) {
            return null;
        }
        if (tabActiveKey === UserSelTab.org) {
            return getOrgListNode();
        }
        else if (tabActiveKey === UserSelTab.business) {
            return getBusinessListNode(tabActiveKey);
        }
        else if (tabActiveKey === UserSelTab.recommend) {
            return getRecommendListNode(tabActiveKey);
        }
        else if (tabActiveKey === UserSelTab.group) {
            return getGroupListNode(tabActiveKey);
        }
        else if (tabActiveKey === UserSelTab.tag) {
            return getTagListNode(tabActiveKey);
        }
        else if (tabActiveKey === UserSelTab.externalContacts) {
            return getContactsListNode(tabActiveKey);
        }
        else if (customTabs &&
            customTabs.length > 0 &&
            customTabs.findIndex(function (item) { return item.tabName === tabActiveKey; }) > -1) {
            return getCustomListNode(tabActiveKey, customTabs.find(function (item) { return item.tabName === tabActiveKey; }));
        }
        else if (tabActiveKey === UserSelTab.workLine) {
            return getWorkLineListNode();
        }
        // else if (tabActiveKey === UserSelTab.groupAndMembers) {
        //     return groupAndMembersNode()
        // }
        else {
            return getCommonListNode(tabActiveKey);
        }
    };
    return (React.createElement(Tabs, { className: "user-selection-tab", activeKey: tabActiveKey, onTabClick: onTabClick }, tabs.map(function (key) {
        return getTabPaneNameNode(key).map(function (item) { return (React.createElement(Tabs.TabPane, { key: item.key, tab: item.tabName, className: "user-selection-tab-pane" }, getTabPaneListNode("" + item.key))); });
    })));
}
//# sourceMappingURL=index.js.map